import { createAction, props } from "@ngrx/store";
import { RiskStatus } from "./auth.model";
import { CheckDigitalProfileResponse, ProfileDetails, RegisterNewProfileResponse, UserEmailAddress, UserPhoneDetails } from "src/app/models/sign-in.models";

export enum AuthActions {
    setWalletId = '[Auth] setWalletId',
    setFirebaseAuthToken = '[Auth] setFirebaseAuthToken',
    setEmailAddress = '[Auth] setEmailAddress',
    setRisk = '[Auth] setRisk',
    getPhoneByWalletIdFound = '[Auth] getPhoneByWalletIdFound',
    getPhoneByWalletIdNotFound = '[Auth] getPhoneByWalletIdNotFound',
    checkDigitalProfile = '[Auth] checkDigitalProfile',
    checkDigitalProfileFound = '[Auth] checkDigitalProfileFound',
    checkDigitalProfileNotFound = '[Auth] checkDigitalProfileNotFound',
    registerNewProfile = '[Auth] registerNewProfile',
    registerNewProfileSuccess = '[Auth] registerNewProfileSuccess',
    createProfileProductTypeSuccess = '[Auth] createProfileProductTypeSuccess',
    updateProfileProductType = '[Auth] updateProfileProductType',
    updateProfileProductTypeSuccess = '[Auth] updateProfileProductTypeSuccess'
}

export const SetWalletId = createAction(
    AuthActions.setWalletId,
    props<{ walletId: string }>()
)

export const SetFirebaseAuthToken = createAction(
    AuthActions.setFirebaseAuthToken,
    props<{ firebaseAuthToken: string }>()
)

export const SetEmailAddress = createAction(
    AuthActions.setEmailAddress,
    props<UserEmailAddress>()
)

export const SetRisk = createAction(
    AuthActions.setRisk,
    props<{ risk: 'ALLOW' | 'DECLINE' | 'WAIT' }>()
)

export const GetPhoneByWalletIdFound = createAction(
    AuthActions.getPhoneByWalletIdFound,
    props<{phoneDetails: UserPhoneDetails, digitalProfileId: string, riskStatus: RiskStatus | null}>()
)

export const GetPhoneByWalletIdNotFound = createAction(
    AuthActions.getPhoneByWalletIdNotFound
)

export const CheckDigitalProfile = createAction(
    AuthActions.checkDigitalProfile,
    props<UserPhoneDetails>()
)

export const CheckDigitalProfileFound = createAction(
    AuthActions.checkDigitalProfileFound,
    props<CheckDigitalProfileResponse>()
)

export const CheckDigitalProfileNotFound = createAction(
    AuthActions.checkDigitalProfileNotFound,
    props<CheckDigitalProfileResponse>()
)

export const RegisterNewProfile = createAction(
    AuthActions.registerNewProfile,
    props<ProfileDetails>()
)

export const RegisterNewProfileSuccess = createAction(
    AuthActions.registerNewProfileSuccess,
    props<{res: RegisterNewProfileResponse, riskStatus: RiskStatus, walletId: string, fbAuthToken: string}>()
)

export const CreateProfileProductTypeSuccess = createAction(
    AuthActions.createProfileProductTypeSuccess
)

export const UpdateProfileProductType = createAction(
    AuthActions.updateProfileProductType,
    props<{ dpid: string, walletId: string, fbAuthToken: string }>()
)

export const UpdateProfileProductTypeSuccess = createAction(
    AuthActions.updateProfileProductTypeSuccess
)
// Todo: Tim: #may6 - GetPhoneByWalletIdFailed error handling